export function mergeStoriesWithNative(targetStories = [], nativeStories = []) {
  const nativeById = new Map(nativeStories.map((story) => [story.id, story]));
  return targetStories.map((story) => {
    const nativeStory = nativeById.get(story.id);
    return {
      ...story,
      nativeTitle: nativeStory?.title || '',
      nativeContent: nativeStory?.content || '',
    };
  });
}

export function hasDistinctNativeStory(story) {
  return Boolean(
    story?.nativeContent
      && (story.nativeContent !== story.content || story.nativeTitle !== story.title),
  );
}
